var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinances(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8662 15.9674V17.02C20.8662 18.183 19.9242 19.125 18.7612 19.125H4.02593C2.8629 19.125 1.9209 18.183 1.9209 17.02V2.28472C1.9209 1.12169 2.8629 0.179688 4.02593 0.179688H18.7612C19.9242 0.179688 20.8662 1.12169 20.8662 2.28472V3.33724H11.3936C10.2305 3.33724 9.28852 4.27924 9.28852 5.44227V13.8624C9.28852 15.0254 10.2305 15.9674 11.3936 15.9674H20.8662ZM11.3936 13.8624H21.9187V5.44227H11.3936V13.8624ZM15.6036 11.2311C14.73 11.2311 14.0248 10.5259 14.0248 9.65234C14.0248 8.77876 14.73 8.07357 15.6036 8.07357C16.4772 8.07357 17.1824 8.77876 17.1824 9.65234C17.1824 10.5259 16.4772 11.2311 15.6036 11.2311Z",
    fill: "#ADB5BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9978,
    height: 18.9453,
    fill: "white",
    transform: "translate(1.9209 0.179688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinances);
export default __webpack_public_path__ + "static/media/finances.a6a12a3eaf94fd5ad55f7cba8eb9347c.svg";
export { ForwardRef as ReactComponent };